let newDate = new Date()
let date = newDate.getDate();
let month = newDate.getMonth() + 1;
let year = newDate.getFullYear();
let hr = newDate.getHours();
let min = newDate.getMinutes();
let seg = newDate.getSeconds();

let mes = month<10?`0${month}`:`${month}`; 
let diaHoy = date<10 ?`0${date}`:date;
let diaTomorrow = date+1<10 ?`0${date+1}`:date+1;

let horas = hr<10?`0${hr}`:`${hr}`; 
let minutos = min<10?`0${min}`:`${min}`; 
let segundos = seg<10?`0${seg}`:`${seg}`; 

let separador = '-';




let fecha = {

    Hoy : () => {
        
        let hoy = `${year}${separador}${mes}${separador}${diaHoy}`; 
        return hoy;
    },
    HoyHora : () => {
        let hoy = `${year}${separador}${mes}${separador}${diaHoy} ${horas}:${minutos}:${segundos}`; 
        return hoy;
    },
    DiaUnoMesActual : () => {
        let hoy = `${year}${separador}${mes}${separador}01`; 
        return hoy;
    },
    Tomorrow : () => {

        let tomorrow = `${year}${separador}${mes}${separador}${diaTomorrow}`;
 
        return tomorrow;
    },

}

export default fecha; 

